import {Model} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {User} from '@/models/User'
import Helper from '../services/Helper.js'



export class Media extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  deleted_at: Date | null

  attachable_type: string | null
  attachable_id: number | null

  content: string| ArrayBuffer | null
  thumbnail: string| ArrayBuffer | null

  constructor(content: any) {
    super();
    this.content = content
  }

  getResourceURL(): string {
    return Helper.setting.media.getResourceAPI
  }




}

export class DataImage extends DataArray {

  declare data: Media

}


export class DataImageArray extends DataArray {

  declare data: Media[]

}

